import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction } from "react";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import FinalizarManutencao from "../../../../Pages/AssistenciaTecnica/Atendimento/AcoesAssistenciaTecnica/FinalizarManutencao";
import { IComponentModal } from "../../../Modais/IModalComponent";
import { IAtendimentoExtraDetalhado } from "../../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import { useUserInfor } from "../../../../Context/User";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { FechamentoSolicitacaoController } from "../../../../Controllers/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoControllers";
import { useHistoricoContext } from "../../../../Context/Historico";
import { IAcoesAcessoUsuario } from "../../../../Interfaces/Geral/AcaoEtapa/AcaoEtapaInterfaces";

interface IBotaoFinalizarReparoProps {
    setShow: Dispatch<SetStateAction<boolean>>;
    setModal: Dispatch<SetStateAction<IComponentModal | undefined>>;
    AcaoAcessoUsuario: IAcoesAcessoUsuario[] | undefined;
}

export default function BotaoFinalizarReparo(
    props: IBotaoFinalizarReparoProps
) {
    const { Atendimento, ID_CASO, updateAtendimento } = useAtendimentoPage();
    const { Config } = useUserInfor();
    const { ReloadHistorico } = useHistoricoContext();

    const config = Config.ConfigAssistenciaTecnicaDTO;

    const {
        execute: FechamentoSolicitacao,
        loading: FechamentoSolicitacaoLoading,
    } = useAsyncCallback(async () => {
        await FechamentoSolicitacaoController({
            idMotivo: 0,
            DadosCustos: {
                ID_CASO: ID_CASO,
            },
            DescricaoMotivo: "",
            flClienteVisualizaistorico: true,
        }).then(() => {
            updateAtendimento();
            ReloadHistorico();
        });
    });

    const AtendimentoDetalhado = Atendimento as IAtendimentoExtraDetalhado;

    if (!Atendimento?.DT_FIM) {
        return (
            <button
                type="button"
                className="btn btn-sm btn-shadow btn-primary"
                onClick={() => {
                    if (config.FL_FINALIZAR_REPARO_SEM_MODAL) {
                        FechamentoSolicitacao();
                    } else {
                        props.setShow(true);
                        props.setModal({
                            headerComponent: "Finalizar Reparo",
                            IconHeader: faCheck,
                            Component: () => (
                                <FinalizarManutencao setShow={props.setShow} />
                            ),
                            size: "lg",
                        });
                    }
                }}
                disabled={
                    // !props.AcaoAcessoUsuario?.find(
                    //     (acaoFiltrada) => acaoFiltrada.ID_ACAO === 28
                    // )?.FL_USUARIO_ACESSA ||
                    AtendimentoDetalhado.FL_SINCRONIZADO === false ||
                    FechamentoSolicitacaoLoading
                }
            >
                <FontAwesomeIcon icon={faCheck} className="mr-2" />
                Finalizar Reparo
            </button>
        );
    } else return null;
}
